/**
 * Fixed footer (plan 6.B): required-items status + Create/Save & copy link.
 */

import React from "react";
import Icon from "../ui/Icon";
import { useBuilder } from "../state/builderContext";
import { footerButtonLabel, footerStatusText } from "../state/selectors";

const BuilderFooter = ({ onPublish, publishing }) => {
  const { state, issues, focusBlock, ready } = useBuilder();
  const count = issues.length;
  const disabled = !ready || publishing || state.save.status === "saving" || count > 0 || state.meta.loading || Boolean(state.meta.loadError);

  const goFirst = () => {
    const first = issues[0];
    if (first) focusBlock(first.anchor, first.section);
  };

  return (
    <footer className="eb-builder-footer">
      <div role={count ? "button" : undefined} tabIndex={count ? 0 : undefined} onClick={count ? goFirst : undefined} onKeyDown={count ? (e) => e.key === "Enter" && goFirst() : undefined} style={count ? { cursor: "pointer" } : undefined}>
        <Icon name="check" size={17} />
        <span>{footerStatusText(count)}</span>
      </div>
      <button type="button" onClick={onPublish} disabled={disabled}>
        <Icon name="link" size={19} />
        {footerButtonLabel(state)}
      </button>
    </footer>
  );
};

export default BuilderFooter;
